import axios from 'axios';
import Swal from 'sweetalert2';
export default {
    base(){
        return 'https://cocoonin.hengthavy.com/cocoonin/api/';
        //return 'https://localhost:5001/api/';
    },
    api(){
        return axios.create({
            baseURL: this.base(),
            headers: { Authorization: 'Bearer ' + localStorage.getItem('jwt') }
        });
    },
    isValid(res){
        let result = true;
        if(res.status == 401){
            Swal.fire('Warning Message', '401 Unauthorized', 'error');
            return;
        }else if(res.data.Messages.length > 0){
            Swal.fire('Warning Message', res.data.Messages.join(','), 'error');
            return;
        }

        return result;
    }
}
